import React from 'react';
import { Location } from 'history';
import LoggedInHomepage from './homepage/logged_in';
import LoggedOutHomepage from './homepage/logged_out';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { MParticlePageName, trackPageView } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import experiments from '@reverbdotcom/commons/src/experiments';
import { trackCriteoHomepageView } from '@reverbdotcom/commons/src/criteo';
import { LAST_SEARCH_URL } from '../marketplace/marketplace_page';
import { AMPLITUDE_EXPERIMENT_NAMES, trackExposure } from '@reverbdotcom/commons/src/amplitude/analytics';

interface IProps extends IUserContext {
  location?: Location;
}

export class Homepage extends React.Component<IProps, null> {
  componentDidMount() {
    this.logView();
    localStorage.setItem(LAST_SEARCH_URL, undefined);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.location && this.props.location) {
      this.logView();
    }
  }

  logView() {
    const trackedExperiments = [
      experiments.DUMMY,
      experiments.MV_DUMMY,
      experiments.WEB_TYPICAL_NEW_PRICE,
    ];

    trackPageView({
      pageName: MParticlePageName.Homepage,
      experiments: formatExperimentsForEventAttributes(this.props.user, trackedExperiments),
    });

    trackCriteoHomepageView(this.props.user);

    trackExposure(AMPLITUDE_EXPERIMENT_NAMES.WEB_AA_HOME);
  }

  render() {
    if (this.props.user.loggedOut) {
      return <LoggedOutHomepage />;
    }

    return <LoggedInHomepage />;
  }
}

export default withUserContext(Homepage);
